import React from 'react'

interface HintIconProps {
    className?: string
}

export const HintIcon: React.FC<HintIconProps> = ({ className }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15 14C15.3 12.9 15.8 12.1 16.6 11.2C17.6 10.1 18 8.7 18 7.2C18 4 15.3 1.5 12 1.5C8.7 1.5 6 4 6 7.2C6 8.7 6.4 10.1 7.4 11.2C8.2 12.1 8.7 12.9 9 14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 18H15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 21.5H14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
